<template>
  <b-col cols="12">
    <b-table
      class="table-bordered border"
      :fields="fields"
      :items="movement.objects"
      show-empty
      hover
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #cell(titlePermishin)="data">
        <b-form-spinbutton
          v-model="movement.goods[data.index].count"
          :readonly="data.item.isSaved"
          class="m-auto"
          min="0"
          :max="
            data.item.remainder > data.item.other_count
              ? data.item.other_count
              : data.item.remainder
          "
          style="width: 150px"
        />
      </template>

      <template #cell(count)="{ value }">
        {{ $_formatPriceMixin(value) }}
      </template>

      <template #cell(remainder)="{ value }">
        {{ $_formatPriceMixin(value) }}
      </template>

      <template #cell(notEnough)="data">
        {{
          data.item.other_count > data.item.remainder
            ? data.item.other_count - data.item.remainder
            : 0
        }}
      </template>

      <template #cell(actions)="data">
        <span class="d-flex">
          <b-button
            variant="primary"
            size="sm"
            class="ml-50 mt-50 mb-50"
            @click="$router.push(`/applications/material/view/${movement.requirement}`)"
          >
            <feather-icon icon="ChevronsRightIcon" size="18" />
          </b-button>
        </span>
      </template>
    </b-table>
  </b-col>
</template>

<script>
import {
  BButton,
  BCol,
  BTable,
  BFormSpinbutton,
} from "bootstrap-vue";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import loader from "@/mixins/loader";

export default {
  components: {
    BCol,
    BTable,
    BButton,
    BFormSpinbutton,
  },
  mixins: [priceFormatMixin, loader],
  props: {
    movement: {
      type: Object,
      default: () => ({}),
    },
    checkIsSaved: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({


    // ===============  PRIMARY_DATA_SECTION START ===============
    fields: [
      {
        label: "ID",
        key: "id",
        thClass: "text-center",
        tdClass: "text-center",
        thStyle: { width: "5%" },
      },
      {
        label: "courses.type",
        key: "good.product.title",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "namee",
        key: "good.value",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "move_request",
        key: "count",
        thClass: "text-center",
        tdClass: "text-center",
        thStyle: { width: "20%" },
      },
      {
        label: "remaining_stock",
        key: "remainder",
        thClass: "text-center",
        tdClass: "text-center",
        thStyle: { width: "20%" },
      },
      {
        label: "lacks",
        key: "notEnough",
        thClass: "text-center",
        tdClass: "text-center",
        thStyle: { width: "20%" },
      },
      {
        label: 'actions',
        key: 'actions',
        thClass: 'text-center',
        tdClass: 'text-center',
        thStyle: { width: '5%' },
      },
    ],
    // ===============  PRIMARY_DATA_SECTION END ===============



  }),
  async mounted() {
    await this.$_loaderStart();
  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
};
</script>

<style>
</style>
